module.exports = __webpack_public_path__ + "static/img/pic_login.e2269785.png";